<template>
  <div class="reset-password">
    <div class="form-box">
      <h3>{{ $t('resetpassword.title') }}</h3>
      <div v-if="status && status != undefined && status.length > 0">
        {{ status }}
      </div>
      <div v-else>
        <form id="sign-in-form" @submit.prevent="onSubmit">
          <b-field>
            <div style="width: 400px; whitespace: no-wrap; padding-right: 10px;">
              <input
                password-input
                v-model="password"
                required="true"
                maxlength="8000"
                :placeholder="$t('resetpassword.password')"
                :type="passShowing ? 'text' : 'password'"
                icon="lock"
                class="input"
              />
            </div>
            <button @click="togglePass" aria-hidden="true">
              <Transition name="fade">
                <img
                  v-if="!passShowing"
                  src="@/assets/icons/visibility-off.svg"
                  style="vertical-align: middle"
                />
              </Transition>
              <Transition name="fade">
                <img
                  v-if="passShowing"
                  src="@/assets/icons/visibility-on.svg"
                  style="vertical-align: middle"
                />
              </Transition>
            </button>
          </b-field>
          <b-field>
            <div style="width: 400px; whitespace: no-wrap; padding-right: 10px;">
              <input
                password-input
                v-model="confirm"
                required="true"
                maxlength="8000"
                :placeholder="$t('resetpassword.confirm')"
                :type="passShowingTwo ? 'text' : 'password'"
                icon="lock"
                class="input"
              />
            </div>
            <b-field>
              <button @click="togglePassTwo" aria-hidden="true">
                <Transition name="fade">
                  <img
                    v-if="!passShowingTwo"
                    src="@/assets/icons/visibility-off.svg"
                    style="vertical-align: bottom"
                  />
                </Transition>
                <Transition name="fade">
                  <img
                    v-if="passShowingTwo"
                    src="@/assets/icons/visibility-on.svg"
                    style="vertical-align: bottom"
                  />
                </Transition>
              </button>
            </b-field>
          </b-field>
          <div class="field" style="padding-right: 35px;">
            <input type="submit" class="button is-primary is-pulled-right" value="Submit" />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { KMS_BACKEND } from '@/config'
import axios from 'axios'
import { notifyMessage, notifyError } from '@/services/notify'



export default {
  data: () => ({
    isDebug: true,
    password: '',
    confirm: '',
    token: '',
    userId: '',
    existingUser: null,
    status: '',
    toggle: false,
    passShowing: false,
    passShowingTwo: false
  }),

  metaInfo: {
    title: 'Forgot Password'
  },

  watch: {

  },

  computed: {
  },

  mounted() {
    this.token = this.$route.query.t
    this.userId = this.$route.query.u

    if(!this.token || this.token == undefined || !this.userId || this.userId == undefined)
    {
      this.status = 'Invalid Reset Password Parameters'
    }
  },

  methods: {
   async onSubmit() {
      const { password, confirm } = this

      if(!password || password == undefined || !this.token || this.token == undefined || !this.userId || this.userId == undefined)
      {
        notifyError(`There was a problem processing your password reset.`)
        return
      }

      if(password != confirm)
      {
        notifyError("The new password and confirmation must match before proceeding.")
        return
      }

      const payload = {
        UserID: this.userId,
        ResetPasswordToken: this.token,
        NewPassword: password
      }

      var errMessage = ''
      try {
        if(this.isDebug == true) console.debug('onSubmit payload=' + JSON.stringify(payload))

        const path = `${KMS_BACKEND}/User/ResetPassword`

        const result = await axios.post(path, payload).catch((e) => {
          console.debug('400 error for password reset=' + e.response.data.message)
          errMessage = e.response && e.response.data !== undefined && e.response.data.message !== undefined && e.response.data && e.response.data.message ? e.response.data.message : 'There was a problem resetting your password.'
          })

        if(this.isDebug==true) console.debug('result=' + JSON.stringify(result))

        if (result && result.status && result.status == 200) {
          notifyMessage('Your password was successfully reset.')
          this.$router.push('/signin')
        }
        else
        {
          notifyError(errMessage)
        }
      } catch(e)
      {
        notifyError(errMessage)
        console.debug(e)
      }
    },
   togglePass(e) {
     e.preventDefault()
     e.stopPropagation()

     this.passShowing = !this.passShowing
   },
   togglePassTwo(e) {
     e.preventDefault()
     e.stopPropagation()

     this.passShowingTwo = !this.passShowingTwo
   },
  }
}
</script>
<style lang="scss" scoped>
.form-box {
  max-width: 480px;
}
.eyeButtons {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translateX(-50%) translateY(-50%);
}
.reset-password {
  display: flex;
  height: 100%;
  min-height: 75vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.input {
  height: 100%;
  width: 100%;
  font-size: 1.15rem;
  &:active,
  &:focus {
    border: none;
    box-shadow: none;
  }
}
</style>
